// Bad Idea Co. (customer 1, the sister company) has never had a sales order. Its filler parts that ride on another
// customer's shared cut sheet (KC0001 and friends) go to Bad Idea stock: AutoShip_BadIdea ships them and the weekly
// Bad Idea auto-invoice bills them. So they need no allocation to an order, and a Time & Materials order is priced
// without them (jobq-api `_tm_bad_idea_part` / `_BAD_IDEA_RIDER_INVOICE_SQL`, 2026-10-14).
export const BAD_IDEA_CUSTOMER_ID = 1;

export function isBadIdeaCustomer(customerId) {
  return customerId != null && customerId !== '' && Number(customerId) === BAD_IDEA_CUSTOMER_ID;
}
